import type { ReactNode } from 'react';
import { Tag, type TagSize } from '@viquard/doc-ui/components';
import { IcnRefresh } from '@viquard/doc-ui/icons';
import type { CalendarEvent } from '../types.js';
import { useCalendarMessages } from '../i18n.js';

export interface RecurrenceBadgeProps {
  readonly event: CalendarEvent;
  readonly size?: TagSize | undefined;
}

/**
 * Visual marker that an event repeats. doc-ui `Tag` (neutral tone) with
 * a leading refresh icon and "repeats" label. Triggered by either the
 * visual-only `recurring: true` flag OR the presence of an actual
 * `recurrence` RRULE string.
 */
export function RecurrenceBadge(props: RecurrenceBadgeProps): ReactNode {
  const { event, size = 'sm' } = props;
  const messages = useCalendarMessages();
  const repeats =
    event.recurring === true ||
    (event.recurrence !== null && event.recurrence !== undefined && event.recurrence.length > 0);
  if (!repeats) return null;
  const px = size === 'sm' ? 11 : 13;
  return (
    <Tag tone="neutral" size={size} title={event.recurrence ?? messages.eventRepeatsLabel}>
      <span className="vq-cal__recur-inner" aria-hidden="true">
        <IcnRefresh size={px} />
        <span>{messages.eventRepeatsLabel}</span>
      </span>
    </Tag>
  );
}
